import React, { useContext, useState } from 'react';

import { ProjectContext } from '../../state/project-state/project-state';
import { Icon } from '../icon/icon';
import { IntegrationsContext } from '../integrations/state/integrations-state';
import { Stack } from '../stack/stack';
import { Table } from '../table/table';
import { EditDongleRegistrationDialog } from './edit-dongle-registration-dialog';
import { UnregisterDongleDialog } from './unregister-dongle-dialog';

export interface RegisteredDongle {
  id: string;
  version?: string | null;
  companyId: string;
  name?: string | null;
  status?: 'ACTIVE' | 'DISABLED';
  projectId: string;
  userId?: string;
}

const DongleListCompanyAdmin = () => {
  const { skyMapDongles, skyMapDongleRegistrations, loadDonglesConnection } =
    useContext(IntegrationsContext);
  const { project } = useContext(ProjectContext);

  const [selectedDongleRemove, setSelectedDongleRemove] = useState<RegisteredDongle>();
  const [selectedDongleEdit, setSelectedDongleEdit] = useState<RegisteredDongle>();
  const registeredDongles: RegisteredDongle[] = skyMapDongleRegistrations.map((registration) => {
    const dongle = skyMapDongles.find((dongle) => dongle.id === registration.skyMapConnectDongleId);
    return {
      id: registration.skyMapConnectDongleId,
      version: dongle?.version,
      companyId: dongle?.companyId ?? '',
      name: dongle?.name,
      status: dongle?.status,
      projectId: registration.projectId,
      userId: registration.userId ?? undefined,
    };
  });

  return (
    <>
      <Table>
        <Table.Head>
          <Table.Row>
            <Table.HeaderCell>Id</Table.HeaderCell>
            <Table.HeaderCell>Enhetsnamn</Table.HeaderCell>
            <Table.HeaderCell>Administratör</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell />
          </Table.Row>
        </Table.Head>

        <Table.Body>
          {registeredDongles.map((dongle: RegisteredDongle) => (
            <Table.Row key={dongle.id} selected={true}>
              <Table.Cell>{dongle.id}</Table.Cell>
              <Table.Cell>{dongle.name}</Table.Cell>
              <Table.Cell>
                {project.companyAdmins.find((user) => user.id === dongle.userId)?.email ?? '-'}
              </Table.Cell>
              <Table.Cell shrink={true}>{dongle.status}</Table.Cell>
              <Table.Cell shrink={true}>
                <Stack direction="row" spacing={0.5}>
                  <Icon
                    fixedWidth={true}
                    icon={['fad', 'pen']}
                    title="Redigera"
                    onClick={() => setSelectedDongleEdit(dongle)}
                  />

                  <Icon
                    fixedWidth={true}
                    icon={['fad', 'trash']}
                    title="Ta bort"
                    onClick={() => setSelectedDongleRemove(dongle)}
                  />
                </Stack>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      {selectedDongleRemove && (
        <UnregisterDongleDialog
          loadDonglesConnection={loadDonglesConnection}
          selectedDongle={selectedDongleRemove}
          onClose={() => setSelectedDongleRemove(undefined)}
        />
      )}
      {selectedDongleEdit && (
        <EditDongleRegistrationDialog
          loadDonglesConnection={loadDonglesConnection}
          selectedDongle={selectedDongleEdit}
          onClose={() => setSelectedDongleEdit(undefined)}
        />
      )}
    </>
  );
};

export default DongleListCompanyAdmin;
